/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NbAuthOAuth2JWTToken, NbPasswordAuthStrategy } from '@nebular/auth';
import { environment } from '../../environments/environment';

export const socialLinks = [
  {
    url: 'https://github.com/akveo/nebular',
    target: '_blank',
    icon: 'github',
  },
  {
    url: 'https://www.facebook.com/akveo/',
    target: '_blank',
    icon: 'facebook',
  },
  {
    url: 'https://twitter.com/akveo_inc',
    target: '_blank',
    icon: 'twitter',
  },
];

export const authOptions = {
  strategies: [
    NbPasswordAuthStrategy.setup({
      name: 'email',
      baseEndpoint: environment.apiUrl,
      token: {
        class: NbAuthOAuth2JWTToken,
        key: 'token',
      },
      login: {
        endpoint: '/auth/login',
        method: 'post',
        defaultErrors: ['El correo eletrónico o usuario y/o contraseña no son correctos, por favor vuelva a intentarlo.'],
        defaultMessages: ['Has ingresado exitosamente.'],
      },
      register: {
        endpoint: '/auth/sign-up',
        method: 'post',
        redirect: {
          success: '/auth/sign-up',
          failure: '/auth/sign-up',
        },
        defaultErrors: ['Algo inesperado paso, por favor vuelva a intentarlo.'],
        defaultMessages: ['Has registrado correctamente el usuario.'],
      },
      logout: {
        endpoint: '/auth/sign-out',
        method: 'post',
        defaultErrors: ['Algo inesperado paso, por favor vuelva a intentarlo.'],
        defaultMessages: ['Cerraste sesión exitosamente.'],
      },
      requestPass: {
        endpoint: '/auth/request-pass',
        method: 'post',
        defaultErrors: ['Algo inesperado paso, por favor vuelva a intentarlo.'],
        defaultMessages: ['Las instrucciones para reiniciar tu contraseña se han enviado a tu correo electrónico.'],
      },
      resetPass: {
        endpoint: '/auth/reset-pass',
        method: 'post',
        defaultErrors: ['Algo inesperado paso, por favor vuelva a intentarlo.'],
        defaultMessages: ['Tu contraseña se ha cambiado exitosamente.'],
      },
      refreshToken: {
        endpoint: '/auth/refresh-token',
        method: 'post',
      },
    }),
  ],
  forms: {
    login: {
      socialLinks: socialLinks,
    },
    register: {
      socialLinks: socialLinks,
    },
  },
};
